export enum ResourceEntityCategory {
  SEMANTIC,
  PII
}
